var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReach(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FC2361",
    fillRule: "evenodd",
    d: "M9 1.8a1.44 1.44 0 00-.72 2.686v.98c0 .392.318.71.71.71h.018a.71.71 0 00.712-.71v-.981A1.44 1.44 0 009 1.8zM3.24 4.68a1.44 1.44 0 10.793 2.64l1.484.743c.34.17.732.012.903-.327l.012-.027c.177-.343.074-.76-.271-.934l-1.485-.742A1.44 1.44 0 003.24 4.68zm11.52 0c-.76 0-1.39.593-1.436 1.353l-1.485.742c-.345.173-.449.591-.271.934l.012.025c.172.34.563.5.903.33l1.485-.743a1.44 1.44 0 10.792-2.64zM9 7.56a1.44 1.44 0 100 2.88 1.44 1.44 0 000-2.88zm3.223 2.308a.697.697 0 00-.643.396l-.012.027c-.177.343-.074.76.271.934l1.485.742a1.44 1.44 0 10.643-1.288l-1.484-.742a.64.64 0 00-.26-.07zm-6.446.001a.638.638 0 00-.26.068l-1.485.742a1.44 1.44 0 10.644 1.288l1.485-.74c.345-.174.449-.592.271-.935l-.012-.026a.697.697 0 00-.643-.397zm3.215 1.955a.71.71 0 00-.712.71v.981a1.44 1.44 0 101.44-.001v-.98a.71.71 0 00-.71-.71h-.018z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReach);
export default __webpack_public_path__ + "static/media/reach.8bbac060a6194c8bc0d101ed7e0432f7.svg";
export { ForwardRef as ReactComponent };